<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

/**
 * FAQs component
 */
export default {
  page: {
    title: "FAQs",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "FAQs",
      items: [
        {
          text: "Utility",
          href: "/"
        },
        {
          text: "FAQs",
          active: true
        }
      ]
    };
  }
};
</script>
<template>
  <Layout>
    <PageHeader :title="$t('menuitems.faq.text')"/>
    <div class="checkout-tabs">
      <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-xl-2 col-sm-3">
        <b-tab active>
          <template v-slot:title>
            <i class="bx bx-question-mark d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">{{ $t('menuitems.faq.generalQuestions.text') }}</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane fade show active">
                  <h4 class="card-title mb-5">{{ $t('menuitems.faq.generalQuestions.text') }}</h4>
                  <div class="faq-box d-flex mb-4">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">{{ $t('menuitems.faq.generalQuestions.ques1.ques') }}</h5>
                      <p
                        class="text-muted"
                      >{{ $t('menuitems.faq.generalQuestions.ques1.answer') }}</p>
                    </div>
                  </div>
                  <div class="faq-box d-flex mb-4">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">{{ $t('menuitems.faq.generalQuestions.ques2.ques') }}</h5>
                      <p
                        class="text-muted"
                      >{{ $t('menuitems.faq.generalQuestions.ques2.answer') }}</p>
                    </div>
                  </div>
                  <!--<div class="faq-box d-flex mb-4">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">Where can I get some?</h5>
                      <p
                        class="text-muted"
                      >If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual languages.</p>
                    </div>
                  </div>-->
                  <div class="faq-box d-flex mb-4">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">{{ $t('menuitems.faq.generalQuestions.ques3.ques') }}</h5>
                      <p
                        class="text-muted"
                      >{{ $t('menuitems.faq.generalQuestions.ques3.answer') }}</p>
                    </div>
                  </div>
                  <div class="faq-box d-flex">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">{{ $t('menuitems.faq.generalQuestions.ques4.ques') }}</h5>
                      <p
                        class="text-muted"
                      >{{ $t('menuitems.faq.generalQuestions.ques4.answer') }}.</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
          </b-card-text>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <i class="bx bx-check-shield d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">{{ $t('menuitems.faq.privacyPolicy.text') }}</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane">
                  <h4 class="card-title mb-5">{{ $t('menuitems.faq.privacyPolicy.text') }}</h4>

                  <div class="faq-box d-flex mb-4">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">{{ $t('menuitems.faq.privacyPolicy.ques1.ques') }}</h5>
                      <p
                        class="text-muted"
                      >{{ $t('menuitems.faq.privacyPolicy.ques1.answer') }}</p>
                    </div>
                  </div>
                  <div class="faq-box d-flex mb-4">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">{{ $t('menuitems.faq.privacyPolicy.ques2.ques') }}</h5>
                      <p
                        class="text-muted"
                      >{{ $t('menuitems.faq.privacyPolicy.ques2.answer') }} <a target="_blank" href="https://workrhythm.net/eula/">{{ $t('menuitems.faq.privacyPolicy.ques2.here') }}</a>.</p>
                    </div>
                  </div>
                  <!--<div class="faq-box d-flex mb-4">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">What is Lorem Ipsum?</h5>
                      <p
                        class="text-muted"
                      >New common language will be more simple and regular than the existing European languages. It will be as simple as occidental.</p>
                    </div>
                  </div>
                  <div class="faq-box d-flex mb-4">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">Why do we use it?</h5>
                      <p
                        class="text-muted"
                      >Their separate existence is a myth. For science, music, sport, etc, Europe uses the same vocabulary.</p>
                    </div>
                  </div>
                  <div class="faq-box d-flex">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">Where can I get some?</h5>
                      <p
                        class="text-muted"
                      >If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual languages.</p>
                    </div>
                  </div>-->
                </div>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
          </b-card-text>
        </b-tab>
        <b-tab title-item-class="mb-2">
          <template v-slot:title>
            <i class="bx bx-support d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">{{ $t('menuitems.faq.support.text') }}</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane">
                  <h4 class="card-title mb-5">{{ $t('menuitems.faq.support.text') }}</h4>

                  <div class="faq-box d-flex mb-4">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">{{ $t('menuitems.faq.support.ques1.ques') }}</h5>
                      <p
                        class="text-muted"
                      >{{ $t('menuitems.faq.support.ques1.answer') }} <span class="fw-bold">support@workrhythm.net</span>.</p>
                    </div>
                  </div>
                  <div class="faq-box d-flex mb-4">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">{{ $t('menuitems.faq.support.ques2.ques') }}</h5>
                      <p
                        class="text-muted"
                      >{{ $t('menuitems.faq.support.ques2.answer') }} <a target="_blank" href="https://wa.me/message/ISYDHG6AOQZMP1">{{ $t('menuitems.faq.support.ques2.chatNow') }}</a></p>
                    </div>
                  </div>

                 <!-- <div class="faq-box d-flex mb-4">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">Why do we use it?</h5>
                      <p
                        class="text-muted"
                      >Their separate existence is a myth. For science, music, sport, etc, Europe uses the same vocabulary.</p>
                    </div>
                  </div>
                  <div class="faq-box d-flex mb-4">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">Where can I get some?</h5>
                      <p
                        class="text-muted"
                      >If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual languages.</p>
                    </div>
                  </div>

                  <div class="faq-box d-flex">
                    <div class="faq-icon me-3">
                      <i class="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-15">What is Lorem Ipsum?</h5>
                      <p
                        class="text-muted"
                      >New common language will be more simple and regular than the existing European languages. It will be as simple as occidental.</p>
                    </div>
                  </div>-->
                </div>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>
  </Layout>
</template>